import React, { useState, lazy } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDownIcon } from 'lucide-react';
const modules = [{
  id: 'M1',
  title: 'Volvé a Ser Vos',
  subtitle: 'La reconexión que nadie te enseña',
  image: 'https://images.unsplash.com/photo-1518611012118-696072aa579a?auto=format&fit=crop&w=320&q=60',
  desc: 'Antes de correr HYROX, tenés que volver a sentirte vos. Este módulo te ayuda a reconectar con tu cuerpo, definir tu punto de partida real y construir la base mental y física para que esta vez sea diferente.',
  bullets: ['Diagnóstico honesto de tu punto de partida', 'Sistema de reconexión cuerpo y hábito', 'Base sólida para que no abandones en la semana 3']
}, {
  id: 'M2',
  title: 'Tu Cuerpo, Tu Ritmo',
  subtitle: 'Plan de entrenamiento real para tu vida real',
  image: 'https://images.unsplash.com/photo-1599058917212-d750089bc07e?auto=format&fit=crop&w=320&q=60',
  desc: '30 días de entrenamiento progresivo diseñado para mujeres que vuelven a moverse. Versión casa y versión gym. Sin excusas de horario ni equipamiento.',
  bullets: []
}, {
  id: 'M3',
  title: 'Resultados Que Se Ven',
  subtitle: 'Sistema de seguimiento y progresión hacia HYROX',
  image: 'https://images.unsplash.com/photo-1571019613454-1cb2f99b2d8b?auto=format&fit=crop&w=320&q=60',
  desc: 'Planillas, métricas y estructura para que cada semana sepas exactamente cuánto avanzaste. El módulo que convierte el esfuerzo en resultados medibles y visibles.',
  bullets: []
}];
export function Modules() {
  const [openId, setOpenId] = useState<string | null>('M1');
  return <section className="py-14 md:py-24 px-4 bg-brand-dark" data-id="element-142">
      <div className="max-w-4xl mx-auto" data-id="element-143">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-8 md:mb-14" data-id="element-144">
          <div className="text-brand-copper font-semibold tracking-widest uppercase text-xs md:text-sm mb-3" data-id="element-145">
            CONTENIDO COMPLETO
          </div>
          <h2 className="text-3xl md:text-6xl text-white mb-3" data-id="element-146">
            LOS 3 <span className="text-brand-pink" data-id="element-147">MÓDULOS</span>
          </h2>
          <p className="text-base md:text-xl text-gray-400" data-id="element-148">
            Tu hoja de ruta para llegar a HYROX desde donde estás hoy
          </p>
        </motion.div>

        <div className="space-y-3" data-id="element-149">
          {modules.map((mod, i) => {
          const isOpen = openId === mod.id;
          return <motion.div key={mod.id} initial={{
            opacity: 0,
            y: 16
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: i * 0.08
          }} className={`bg-brand-black border rounded-2xl overflow-hidden transition-colors ${isOpen ? 'border-brand-pink/40' : 'border-gray-800'}`} data-id="element-150">
                <button onClick={() => setOpenId(isOpen ? null : mod.id)} className="w-full p-3 md:p-4 flex items-center gap-3 md:gap-4 text-left hover:bg-gray-900/40 transition-colors" aria-expanded={isOpen} data-id="element-151">
                  {/* Thumbnail */}
                  <div className="relative flex-shrink-0 w-16 h-16 md:w-20 md:h-20 rounded-xl overflow-hidden" data-id="element-152">
                    <img src={mod.image} alt={mod.title} loading="lazy" decoding="async" width={320} height={320} className="w-full h-full object-cover" data-id="element-153" />
                    <div className="absolute inset-0 bg-gradient-to-t from-black/70 to-transparent" data-id="element-154" />
                    <span className="absolute bottom-1 left-1.5 text-xs font-display text-brand-pink" data-id="element-155">
                      {mod.id}
                    </span>
                  </div>

                  <div className="flex-grow min-w-0" data-id="element-156">
                    <h3 className="text-base md:text-2xl text-white font-bold leading-tight" data-id="element-157">
                      {mod.title}
                    </h3>
                    <p className="text-brand-copper text-xs md:text-base mt-0.5 leading-snug" data-id="element-158">
                      {mod.subtitle}
                    </p>
                  </div>

                  <ChevronDownIcon className={`w-5 h-5 md:w-6 md:h-6 text-gray-500 flex-shrink-0 transition-transform duration-300 ${isOpen ? 'rotate-180 text-brand-pink' : ''}`} data-id="element-159" />
                </button>

                <AnimatePresence initial={false} data-id="element-160">
                  {isOpen && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.3
              }} data-id="element-161">
                      <div className="px-4 pb-5 md:px-5 md:pb-6 text-gray-300" data-id="element-162">
                        <div className="h-px w-full bg-gray-800 mb-4" data-id="element-163" />
                        <p className="text-sm md:text-base leading-relaxed" data-id="element-164">
                          {mod.desc}
                        </p>
                        {mod.bullets.length > 0 && <ul className="space-y-2 mt-4" data-id="element-165">
                            {mod.bullets.map((bullet, idx) => <li key={idx} className="flex items-start gap-2" data-id="element-166">
                                <div className="w-1.5 h-1.5 rounded-full bg-brand-pink mt-1.5 md:mt-2 flex-shrink-0" data-id="element-167" />
                                <span className="text-sm md:text-base" data-id="element-168">
                                  {bullet}
                                </span>
                              </li>)}
                          </ul>}
                      </div>
                    </motion.div>}
                </AnimatePresence>
              </motion.div>;
        })}
        </div>

        <div className="text-center mt-6 text-gray-500 text-xs md:text-sm" data-id="element-169">
          Tocá cada módulo para ver lo que incluye 👆
        </div>
      </div>
    </section>;
}